module.exports = __webpack_public_path__ + "static/media/aces_e2_off.442dc2b5.svg";